'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import useIsSearchOpen from 'global-state/isSearchOpen/useIsSearchOpen';

/**
 * When the search modal is closed, clear the InstantSearch query
 * so the next time the user opens the modal they see an empty search box.
 */
const ClearModalSearchQueryWhenClosed = () => {
  const $ = _c(4);
  const {
    setIndexUiState
  } = useInstantSearch();
  const isSearchOpen = useIsSearchOpen();
  const wasOpenRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== isSearchOpen || $[1] !== setIndexUiState) {
    t0 = () => {
      if (wasOpenRef.current && !isSearchOpen) {
        setIndexUiState(_temp);
      }
      wasOpenRef.current = isSearchOpen;
    };
    t1 = [isSearchOpen, setIndexUiState];
    $[0] = isSearchOpen;
    $[1] = setIndexUiState;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
};
export default ClearModalSearchQueryWhenClosed;
function _temp(prev) {
  return {
    ...prev,
    query: ""
  };
}